import UIkit from 'uikit';

const quickview = () => {

  jQuery(document).ready(function($){
    $(document).on('click','a[data-quickview]',function(e){

        e.preventDefault();

        $('.c-loader').addClass('in');

        var $this   = $(this),
            id      = $(this).data("id"),
            template  = $(this).data("template");

        jQuery.ajax({
            type: "post",
            url: glamyAjax.ajaxurl,
            data: "action=quickview&nonce="+glamyAjax.nonce+"&id="+id+"&template="+template,
            success: function(result){
              $('#quickview .c-modal__body').html(result);
              UIkit.modal('#quickview').show();
              $('.c-loader').removeClass('in');
            },
            error: function(result){
              $('.c-loader').removeClass('in');
            }
        });

        return false;
    });
  });

  UIkit.util.on('#quickview', 'hide', function () {
    jQuery('#quickview .c-modal__body').html('');
  });

};

export default quickview;
